<template>
  <v-list dense v-if="flipAsset.metadata">
    <v-list-item
      v-if="flipAsset.salesModel=='flip'"
      v-for="(detail, d) in detailList()"
      :key="d"
      :class="d % 2 === 0 ? 'blue lighten-5' : ''"
    >
      <v-list-item-content>
        <v-col cols="6" class="pa-0">{{ detail.text }}</v-col>
        <v-col cols="6" class="pa-0 text-right">{{ detail.value }}</v-col>
      </v-list-item-content>
    </v-list-item>
    <v-list-item
      v-if="flipAsset.salesModel=='hold'"
      v-for="(detail, d) in detailListHold()"
      :key="d"
      :class="d % 2 === 0 ? 'blue lighten-5' : ''"
    >
      <v-list-item-content>
        <v-col cols="6" class="pa-0">{{ detail.text }}</v-col>
        <v-col cols="6" class="pa-0 text-right">{{ detail.value }}</v-col>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'AssetDetailsList',

    computed: {
      ...mapGetters([
        'flipAsset',
        'adminAssetHistory',
        'nonAdminAssetHistory'
      ])
    },

    data: () => ({
      pricePerShare: 0,
      paybackPricePerShare: 0,
    }),

    methods: {
      ...mapActions([
        'getPurchaseHistoryForAsset',
        'getNonAdminPurchaseHistoryForAsset',
        'clearPurchaseHistoryForAsset'
      ]),

      detailList: function() {
        let detailListReturn = [
          {
            text: 'Price per Share',
            value: this.$options.filters.numberToMoney(this.pricePerShare)
          },
          {
            text: 'Shares',
            value: this.flipAsset.totalShares
          },
          // Projected/Actual toggle.
          this.flipAsset.salesState === 'Purchased' ? {
            text: 'Realized Shared ROI',
            value: this.flipAsset.actualRoi + '%'
          } : {
            text: 'Projected ROI',
            value: this.flipAsset.metadata.projectedRoi + '%'
          },
          {
            text: 'NR Auction Date',
            value: this.$options.filters.timestampToDate(this.flipAsset.auctionStartTimestamp)
          },
          {
            text: 'Location',
            value: this.flipAsset.metadata.location
          },
          {
            text: 'Consignor',
            value: this.flipAsset.consignor.name
          },
        ];
        if(this.flipAsset.allowBuyItNow) {
          let buyNowObj = {
            text: 'Buy Now Price',
            value: this.$options.filters.numberToMoney(this.flipAsset.buyItNowPrice)
          }
          detailListReturn.splice(4, 0, buyNowObj);
        }
        if (this.flipAsset.salesState === 'Purchased') {
          let investorPerSharePaybackObj = {
            text: 'Price per Share Payout',
            value: this.$options.filters.numberToMoney(this.paybackPricePerShare)
          }
          detailListReturn.splice(1, 0, investorPerSharePaybackObj)
        }
        return detailListReturn;
      },
      detailListHold: function() {
        let detailListHoldReturn = [
          {
            text: 'Price per Share',
            value: this.$options.filters.numberToMoney(this.pricePerShare)
          },
          {
            text: 'Shares',
            value: this.flipAsset.totalShares
          },
          // Projected/Actual toggle.
          // this.flipAsset.salesState === 'Purchased' ? {
          //   text: 'Actual ROI',
          //   value: this.flipAsset.actualRoi + '%'
          // } : {
          //   text: 'Projected ROI',
          //   value: this.flipAsset.metadata.projectedRoi + '%'
          // },
          // this.flipAsset.auctionStartTimestamp !== null ? {
          //   text: 'NR Auction Date',
          //   value: this.$options.filters.timestampToDate(this.flipAsset.auctionStartTimestamp)
          // } : {},
          {
            text: 'Location',
            value: this.flipAsset.metadata.location
          },
          {
            text: 'Consignor',
            value: this.flipAsset.consignor.name
          },
        ];
        if(this.flipAsset.allowBuyItNow) {
          let buyNowObj = {
            text: 'Buy Now Price',
            value: this.$options.filters.numberToMoney(this.flipAsset.buyItNowPrice)
          }
          detailListHoldReturn.splice(4, 0, buyNowObj);
        }
        if (this.flipAsset.salesState === 'Purchased') {
          let investorPerSharePaybackObj = {
            text: 'Price per Share Payout',
            value: this.$options.filters.numberToMoney(this.paybackPricePerShare)
          }
          detailListHoldReturn.splice(1, 0, investorPerSharePaybackObj)
        }
        return detailListHoldReturn;

      }
    },

    async created () {
      this.pricePerShare = this.flipAsset.pricePerShare

      this.clearPurchaseHistoryForAsset()
      if (this.flipAsset.salesState === 'Purchased') {
        await this.getNonAdminPurchaseHistoryForAsset(this.flipAsset.id)
        this.pricePerShare = this.nonAdminAssetHistory.sharePurchasePrice
        this.paybackPricePerShare = this.nonAdminAssetHistory.investorPerSharePayback
      }
    }
  }
</script>
